module.exports = __webpack_public_path__ + "img/ic_24_fitnessplan_date.7f9ae754.svg";